export const ROUTES_WITH_BACK_NAV = [
  "/view/mysettings",
  "/view/account",
  "/view/integration/integrations"
];
